import { render, staticRenderFns } from "./MainWorksProject.vue?vue&type=template&id=7c46a98c&scoped=true&"
import script from "./MainWorksProject.vue?vue&type=script&lang=js&"
export * from "./MainWorksProject.vue?vue&type=script&lang=js&"
import style0 from "./MainWorksProject.vue?vue&type=style&index=0&id=7c46a98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46a98c",
  null
  
)

export default component.exports